module.exports = "<div [ngStyle]=\"{'text-align': position}\" class=\"text-content\" [innerHTML]=section.content></div>\n"